<template>
  <div>
    <div class="course_introduce" v-if="coursewareList.length">
      <div class="course_introduce_content" ref="content" :class="{ expanded: isExpanded }">
        <div class="courseware_title flex FlexBetween">
          <div class="courseware_name">名称</div>
          <!-- <div class="courseware_chapter">所属章节</div> -->
          <div class="courseware_chapter">文件大小</div>
          <div class="courseware_chapter">操作</div>
        </div>
        <div class="courseware_title flex Flexalign FlexBetween" v-for="(item, index) in coursewareList" :key="index">
          <div class="courseware_one flex Flexalign FlexBetween">
            <div class="courseware_name flex Flexalign">
              <el-image class="folder_icon" :src="getFolderIcon(item.fileExt)"></el-image>
              <el-tooltip placement="top" effect="customized" :show-after="1000" :show-arrow='false'>
                <template #content> {{ item.name }} </template>
                <div class="courseware_name_text">
                  {{ item.name }}
                </div>
              </el-tooltip>
            </div>
            <!-- <div class="courseware_chapter">{{ item.belongingChapter }}</div> -->
            <div class="courseware_chapter">
              {{ (item.fileSize / 1048576).toFixed(2) }}M
            </div>
            <div class="courseware_chapter view_free cursor_pointer" v-if="item.userViewPermission == 0"
              @click="viewFolder(item)">
              免费查看
            </div>
            <div class="courseware_chapter view_not_free cursor_pointer" v-if="item.userViewPermission == 1"
              @click="viewFolder(item)">
              付费查看
            </div>
          </div>
        </div>
      </div>
      <div class="more_load flex Flexalign Flexjustify cursor_pointer" v-if="showLoadMore" @click="toggleExpand">
        {{ isExpanded ? "收起" : "加载更多" }}
        <el-icon>
          <ArrowDown />
        </el-icon>
      </div>
    </div>
    <div v-else>
        <moe-empty url="moe_empty_bg_img.png" emptyText="暂无课件资料"></moe-empty>
      </div>
  </div>
</template>

<script>
export default {
  name: "GjkcH5Courseware",
  props: {
    courseId: {},
  },

  data() {
    return {
      isExpanded: false,
      showLoadMore: false,
      coursewareList: [],
    };
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.$nextTick(this.checkOverflow);
      },
    },
  },
  mounted() {
    this.checkOverflow();
    this.getCoursewareList();
  },

  methods: {
    getFolderIcon(type) {
      let iconPath = "";
      if (type == "") {  // 文件夹
        iconPath = "folder_icon";
      } else if (type == ".png" || type == ".jpg") {  // 图片
        iconPath = "img_icon";
      } else if (type == ".pdf") {  // pdf
        iconPath = "pdf_icon";
      } else if (type == ".mp4") {  // 视频
        iconPath = "player_icon";
      } else if (type == ".ppt" || type == '.pptx') {  // ppt
        iconPath = "ppt_icon";
      } else if (type == ".txt") {  // txt文档
        iconPath = "txt_icon";
      } else if (type == ".mp3") {  // 音频
        iconPath = "video_icon";
      } else if (type == ".doc" || type == '.docx') {  // word
        iconPath = "word_icon";
      } else if (type == ".zip" || type == '.rar') {  // 压缩包
        iconPath = "zip_icon";
      } else {
        iconPath = "default_folder_icon";
      }
      return this.imgPath(iconPath + ".png");
    },
    checkOverflow() {
      if (!this.$refs.content) return
      this.showLoadMore =
        this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    getCoursewareList() {
      let params = {
        sceneId: "",
        dirPath: "/",
        name: "",
        page: 1,
        pageSize: 999,
      };
      params.sceneId = this.courseId;
      this.$Api.course
        .getCoursewareList(params)
        .then((res) => {
          this.coursewareList = res.data.data.list;
        })
        .catch((err) => {
          // this.$Dialog.toast(err.data.message, { type: "error" });
          console.log(err);
        });
    },
    // 查看文件
    viewFolder(info) {
      window.open(info.storageUrl);
    },
  },
};
</script>
<style lang="scss" scoped>
.course_introduce {
  // max-height: 550px;
  // overflow: hidden;
  position: relative;

  .course_introduce_content {
    max-height: 500px;
    overflow: hidden;

    .courseware_title {
      width: 100%;
      color: #666666;
      font-weight: 600;
      margin-top: 20px;
      // padding: 0 25px;
      box-sizing: border-box;

      .courseware_name {
        // width: 58%;
        width: 70%;
      }

      .courseware_chapter {
        width: 14%;
        text-align: center;
      }

      .view_free {
        color: rgba(19, 214, 170, 1);
      }

      .view_not_free {
        color: rgba(255, 102, 25, 1);
      }

      .courseware_one {
        width: 100%;
        color: #999999;
        font-weight: normal;

        .folder_icon {
          width: 24px;
          height: 24px;
        }

        .courseware_name_text {
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          white-space: nowrap;
          margin-left: 15px;
        }
      }
    }
  }

  .course_introduce_content.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .more_load {
    width: 100%;
    height: 50px;
    background: #ffffff;
    border-radius: 0px 0px 20px 20px;
    // position: absolute;
    // bottom: 0;
    z-index: 9;
    color: #999999;
  }
}
</style>
